export const ADDRESS_TYPE = {
  SHIPPING: 'shipping',
  BILLING: 'billing',
  LEGAL: 'legal',
  OTHER: 'other',
} as const;

export type AddressType = (typeof ADDRESS_TYPE)[keyof typeof ADDRESS_TYPE];
